// @flow

import React from 'react';
import axios from 'axios';
import { iOS } from '../../helpers/formatUtils';
import i18n from '../../i18n';

const MobileWalletLink = ({
  link, host, gpay, cardNo, variant, customNS
}) => {
  const appleDevice = iOS();

  let linkClass;
  let alt;
  let ariaLabel;
  let imageName;
  let showLink = false;
  let thirdParty = false;
  let buttonText;
  let customButton = false;

  if (!gpay && host && link) {
    // Proprietary wallet
    // host.wallet.image or host.wallet.button value must be in locale en
    linkClass = host.replace(/\./g, '-') + '-pass-link';
    alt = `${host}.wallet`;
    ariaLabel = `${host}.wallet`;
    imageName = `${host}.wallet.image`;
    showLink = true;
    thirdParty = true;
    buttonText = `${host}.wallet.button`;
    customButton = i18n.t(imageName, {ns: customNS}) === imageName;
  } else if (!gpay && appleDevice && link) {
    // Apple wallet
    linkClass = 'apple-pass-link';
    alt = 'applepass.wallet';
    ariaLabel = 'applepass.wallet';
    imageName = 'applepass.image';
    showLink = true;
  } else if (gpay && link) {
    //  Google Pay
    // host.gpay.image must be in locale en
    linkClass = 'gpay-pass-link';
    alt = 'gpay.wallet';
    ariaLabel = 'gpay.wallet';
    let imageVariant;
    switch (variant) {
    case 'DARK':
      imageVariant = 'dark';
      break;
    case 'LIGHT':
      imageVariant = 'light';
      break;
    case 'LIGHT_OUTLINE':
      imageVariant = 'light_outline';
      break;
    default:
      imageVariant = 'dark';
      break;
    }
    imageName = `gpay.image.${imageVariant}`;
    showLink = true;
  }

  const getLinkType = (className) => {
    let linkType;
    if (className === 'apple-pass-link') {
      linkType = 'Apple Wallet';
    } else if (className === 'gpay-pass-link') {
      linkType = 'Google Pay';
    } else {
      linkType = 'Third Party';
    }
    return linkType;
  };

  let image = i18n.t(imageName, {ns: customNS});
  if (gpay && image === imageName) {
    image = i18n.t(image, {ns: customNS});
  }

  const addToWallet = (event) => {
    const linkType = getLinkType(event.currentTarget.className);
    const logEventAPI = `/${window.env.contextPath}/api/logEvent`;
    try {
      const cardNumber = cardNo.replace(/ +/g, '');
      axios.post(logEventAPI, {
        cardNumber,
        linkType,
        appleDevice,
      });
    } catch (err) {
      // ignore error
    }
    if (linkType !== 'Apple Wallet') {
      window.open(link, '_blank');
    } else {
      window.open(link, '_self');
    }
    return false;
  };

  return (
    <>
      {showLink && (
        <a
          id='mobilelink'
          className={linkClass}
          rel='noreferrer'
          onClick={addToWallet}
          href={() => false}
        >
          {thirdParty && customButton ? (
            <div className='wallet-btn client-wallet-btn d-flex'>
              <i className='fas fa-wallet fa-2x mr-2' />
              <div>
                <span className='add-to'>{i18n.t('Add to', {ns: customNS})}</span>
                <br />
                {i18n.t(buttonText, {ns: customNS})}
              </div>
            </div>
          ) : (
            <img
              border='0'
              alt={i18n.t(alt, {ns: customNS})}
              aria-label={i18n.t(ariaLabel, {ns: customNS})}
              src={`${process.env.PUBLIC_URL}/${image}`}
            />
          )}
        </a>
      )}
    </>
  );
};

export default MobileWalletLink;
